const guidesPage = {
  "guides.title": "Guías",
  "guides.passing_basics.title": "Cómo Jugar",
  "guides.passing_basics.description": "Instrucciones básicas sobre cómo jugar.",
  "guides.decision_making.title": "Decisión",
  "guides.decision_making.description": "Instrucciones sobre cómo tomar decisiones.",
  "guides.scan_rate.title": "Frecuencia",
  "guides.scan_rate.description": "Explica la mecánica de la Frecuencia.",
  "guides.scan_timing.title": "Ritmo",
  "guides.scan_timing.description": "Explica la mecánica del Ritmo.",
  "guides.awareness.title": "Memoria",
  "guides.awareness.description": "Aprende cómo funcionan las pruebas de memoria.",
  "guides.critical_scan.title": "Scan Crítico",
  "guides.critical_scan.description": "Instrucciones sobre cómo hacer un Scan Crítico.",
};

const howToPlay = {
  "how-to-play.heading": "Cómo Jugar",
  "how-to-play.description.1": "Usa los marcadores para ubicar el balón y la portería del oponente. ¡Recuerda! Siempre estás en el equipo AZUL.",
  "how-to-play.description.2":
    "En cada escenario recibirás el balón. Aparece una cuadrícula cuando tienes el balón en posesión. ¡Debes mirar el balón para recibirlo!",
  "how-to-play.description.3.1": "¡Encuentra un pase!",
  "how-to-play.description.3.2": "Apunta para dirigir",
  "how-to-play.description.4": "Mira tus manos para verificar tus controles",
};

const scanning = {
  "scanning.heading": "Exploración",
  "scanning.description.1": "Explorar se trata de ver la situación a tu alrededor. Para explorar, mira lejos del balón y luego vuelve a mirarlo.",
  "scanning.description.2.1": "Serás puntuado según tu Tasa de Exploración.",
  "scanning.description.2.2": "Explora tan a menudo como sea posible, recuerda que debes mirar el balón para recibirlo.",
};

const scanTiming = {
  "scan-timing.heading": "Tiempo de Exploración",
  "scan-timing.description.1": "El Tiempo de Exploración consiste en mirar el balón y apartar la mirada en los momentos correctos.",
  "scan-timing.description.2": "Mira el balón cuando se está pateando",
  "scan-timing.description.3": "Mira el balón cuando se está recibiendo",
  "scan-timing.description.4": "Explora cuando el balón esté en el aire",
};

const awareness = {
  "awareness.heading": "Memoria",
  "awareness.description.1": "Durante una prueba, algunos jugadores estarán ocultos.",
  "awareness.description.2": "Elige el equipo correcto para cada jugador.",
  "awareness.description.3": "Una vez que respondas, verás tus resultados.",
  "awareness.description.4": "Solo tienes tiempo limitado para responder, ¡así que sé rápido!",
};

export const guides = {
  ...guidesPage,
  ...howToPlay,
  ...scanning,
  ...scanTiming,
  ...awareness,
};
